<template>
  <div class="auth-block"
       :class="accent ? '_accent' : null"
  >
    <div class="auth-block__inner">
      <form @keypress.enter="onClick" class="auth-block__content">
        <BasePreloader v-if="pending"/>
        <h2 class="auth-block__title">{{ $tAuth('Login') }}</h2>
        <BaseInput v-model="inputs.login.value"
                   :error="inputs.login.error"
                   :label="$tAuth('E-mail or phone number')"
                   class="auth-block__input"
                   name="login"
                   :class="accent ? '_white _shadow' : null"
        />
        <BaseInput v-model="inputs.password.value"
                   :error="inputs.password.error"
                   :label="$tAuth('Password')"
                   class="auth-block__input"
                   name="password"
                   type="password"
                   :class="accent ? '_white _shadow' : null"
        />
        <a href="#" class="auth-block__forgot-pass inline-link"
           @click.prevent="$vModal.open('forgot-pass', {defaultEmailPhone: inputs.login.value})">
          <span>{{ $tAuth('Forgot your password?') }}</span>&nbsp;
          <BaseSvg class="_arrow" name="ico-arrow-light"/>
        </a>
        <BaseCheckbox v-model="remember"
                      :label="$tAuth('To remember me')"
                      class="auth-block__checkbox"
                      :class="accent ? '_white _shadow' : null"
        />
        <BaseAlert :value="overallErrorsMix"
                   class="auth-block__alert  _error"/>
        <button type="button"
                class="auth-block__btn-submit base-btn base-btn--green  specific-login"
                @click.prevent="onClick">
          <span class="base-btn__text">{{ $tAuth('Sign in') }}</span>
        </button>
      </form>
      <AuthSocials class="auth-block__content" v-if="socials"/>
    </div>
  </div>
</template>

<script>
  import formMixins from '../mixins/formMixins'
  import AuthSocials from "./AuthSocials";
  import {EMPLOYEE, EMPLOYER, MODERATOR} from '@/constants/usersTypes'


  export default {
    components: {AuthSocials},
    mixins: [formMixins],
    props: {
      accent: {
        type: Boolean,
        default: false
      },
      socials: {
        type: Boolean,
        default: false
      },
      previousPage: Object
    },
    data() {
      return {
        pending: false,
        inputs: {
          login: {
            value: null,
            error: null,
            required: true
          },
          password: {
            value: null,
            error: null,
            required: true
          }
        },
        remember: true
      }
    },
    methods: {
      onClick() {
        this.resetErrorsMix()

        let r = this.moderateFieldIsRequiredMix(this.inputs.login)
        if (!r) {
          this.isRequiredEmptyMix = true
        }

        r = this.moderateFieldIsRequiredMix(this.inputs.password)
        if (!r) {
          this.isRequiredEmptyMix = true
        }

        if (this.isRequiredEmptyMix) {
          return
        }

        const sendData = {
          password: this.inputs.password.value
        }

        if (/@/.test(this.inputs.login.value)) {
          sendData.email = this.inputs.login.value
        } else {
          sendData.phone = this.inputs.login.value
        }

        this.pending = true;

        this.$store.dispatch('user/loginUser', { sendData, remember: this.remember })
          .then(this.afterLogin)
          .catch(this.errorHandlerMix)
          .finally(() => this.pending = false)
      },
      afterLogin() {
        return this.$store.dispatch('user/loadUser').then((data) => {
          const userType = data.user.user_type
          const matchedRoute = this.$route.query.redirect ? this.$router.matcher.match(this.$route.query.redirect) : null

          if (
            matchedRoute
            && matchedRoute.name
          ) {
            if (!matchedRoute.meta.requiredUserTypes
              || !matchedRoute.meta.requiredUserTypes.length
              || matchedRoute.meta.requiredUserTypes.includes(userType)) {
              return this.$router.push({path: this.$route.query.redirect}).catch(() => ({}))
            } else {
              const title = 'Для вашего аккаунта этот раздел закрыт'
              const message = userType === EMPLOYEE
                ? 'Вы авторизировались как соискатель. Для перехода в этот раздел вам нужно авторизировтся как роботодатель.'
                : 'Вы авторизировались как роботодатель. Для перехода в этот раздел вам нужно авторизировтся как соискатель.'
              this.$vModal.open('warning', {
                title,
                message
              })
            }
          }

          if (this.previousPage && this.previousPage.name !== 'home') {
            this.$router.push(this.previousPage.fullPath)
          } else {

            if (data.user.user_type === EMPLOYEE) {
              this.$router.push({name: 'account-resumes'}).catch(() => ({}))
            } else if (data.user.user_type === EMPLOYER) {
              const name = data.has_responses ? 'account-vacancies-responses' : 'account-vacancies';
              this.$router.push({name}).catch(() => ({}))
            } else if (data.user.user_type === MODERATOR) {
              this.$router.push({name: 'account-moderator'}).catch(() => ({}))
            } else {
              this.$router.push({name: 'home'}).catch(() => ({}))
            }
          }
        })
      }
    }
  }
</script>

<style lang="less">

</style>
